/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Image = {
    properties: {
        cropAspectRatio: {
            type: 'number',
        },
        cropX: {
            type: 'number',
        },
        cropY: {
            type: 'number',
        },
        cropScale: {
            type: 'number',
        },
        id: {
            type: 'string',
            isRequired: true,
        },
        uploadDate: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        uploadedById: {
            type: 'number',
            isRequired: true,
        },
        aspectRatio: {
            type: 'number',
            isRequired: true,
        },
        url: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
